import React from 'react';

import { ConfirmDialogModal } from '@/shared/components/ui/confirm-dialog/components/confirm-dialog-modal/confirm-dialog-modal';
import { TConfirmDialogProps } from '@/shared/components/ui/confirm-dialog/confirm-dialog.types';
import { ModalController } from '@/shared/components/ui/modal-controller/modal-controller';

export const ConfirmDialog: React.FC<TConfirmDialogProps> = ({
  triggerComponent,
  onClose,
  permission,
  ...rest
}) => {
  return (
    <ModalController trigger={triggerComponent} permission={permission}>
      {(onModalClose) => (
        <ConfirmDialogModal
          onClose={(event) => {
            onClose?.(event);
            onModalClose(event);
          }}
          {...rest}
        />
      )}
    </ModalController>
  );
};
